<template>
    <div class="header-desktop" :style="cssProps">
        <div class="logo">
            <a v-smooth-scroll="{duration: 1000, updateHistory: false, offset: -100}" href="#call-to-action">
                <img :src="logo" alt="Engelink" />
            </a>
        </div>
        <div class="nav">
            <ul>
                <li v-for="(item, index) in links" :key="index">
                    <a :href="item.path" v-smooth-scroll="{duration: 1000, updateHistory: false, offset: -50}">{{ item.label }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'desktopComponet',
    props: {
        links: {
            type: Array,
            default: () => {
                return [];
            }
        },
        topOfPage: {
            type: Boolean,
            desktop: true
        }
    },
    computed: {
        logo() {
            return require(`@/assets/images/${this.topOfPage ? 'logo_engelink_credito_negativa.svg' : 'logo_engelink_credito.svg'}`) 
        },
        cssProps() {
            return {
                '--menuColor': this.topOfPage ? '#fff' : '#003f7e'
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.header-desktop {
    max-width: 1120px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    .logo a {
        display: flex;
        align-items: center;
    }
    .nav ul {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 32px;
        margin: 0;
        li {
            font-family: 'Open Sans', sans-serif;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            text-transform: uppercase;
            cursor: pointer;
            a {
                color: var(--menuColor);
            }
        }
    }
}
</style>
